import {Field, FieldInputProps, FormikProps, getIn} from 'formik'
import React from 'react'

import {useAdminPilotUser} from '../../../common/hooks/useAdminPilotUser'
import {useTranslation} from '../../../hooks/useTranslation'
import {Permission} from '../../../modules/LoggedInUser'
import {DataScopes, GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'
import {
  SelectGrouped,
  SelectGroupedOption
} from '../../../pages/ManageUser/components/SelectGrouped'
import {checkRequired} from '../utils'
import {Controller, useFormContext} from "react-hook-form";

type CustomerOrPayerDropdownProps = {
  name: string
  dataScope: string
  options: SelectGroupedOption[]
  onChange: (value: string) => void
  disabled?: boolean
  loggedInUserPermissions?: Permission[] | null
}
export const CustomerOrPayerDropdown = ({
  dataScope,
  name,
  options,
  onChange,
  disabled = false,
  loggedInUserPermissions
}: CustomerOrPayerDropdownProps) => {
  const {t} = useTranslation()
  const isUserAdminPilot = useAdminPilotUser(loggedInUserPermissions)
  const {control} = useFormContext<GroupedRoleAssignment>()

  return (
    <Controller
      name={name as keyof GroupedRoleAssignment}
      rules={{validate: checkRequired(!isUserAdminPilot, false, t(`roleAssignment.noValue.${dataScope}`))}}
      control={control}
      render={({
        field
      }) => (
        <SelectGrouped
          {...field}
          searchPlaceholder="Search customer..."
          value={field.value ? field.value.toString() : ''}
          onChange={(value: string) => {
            field.onChange(value)
            onChange(value)
          }}
          inputLabel={t(`roleAssignment.dataScope.${dataScope}`)}
          options={options}
          disabled={disabled}
        />
      )}
  />
  )
}
